export const mewoEvents = (k) =>{
    mewoHoverEvent(k);
}

const mewoHoverEvent = (k) =>{
        k.onHover("mewo", (omori2) => {
        k.debug.log("Is hovered")
          const select = add([
            rect(120, 122),
            color(217, 217, 217),
            pos(24, 160),
            z(1),
            opacity(0.4),
            "select2"
        ])
    })

    k.onHoverEnd("mewo", (omori)=>{
        k.debug.log("Termino el hover")
        const selectAubrey = k.get("select2")[0];
        k.destroy(selectAubrey);
    })
}